import { createFileRoute } from "@tanstack/react-router"
import { PrivacyTab } from "./_privacy-tab"

export const Route = createFileRoute("/settings/privacy")({
  component: PrivacyTab,
})
